module.exports = __webpack_public_path__ + "img/floating-menu_close.c702d7c7.svg";